
<mat-dialog-actions fxLayoutAlign="end">
  <button mat-button
          [matDialogClose]="true">Fermer</button>
</mat-dialog-actions>
<app-rendu-formulaire *ngIf="formModel"
                      [formModel]="formModel"
                      [displayManagement]="false"></app-rendu-formulaire>
